import React from 'react'
import InfoTemplate from 'containers/list/info_types/info_template'
import ProductDetailsPage from 'containers/list/info_types/product_details_page'

const ProductInfo = (props) => {
  const { product } = props
  const { info_type } = product || {}

  switch (info_type) {
    case 'info_template':
      return <InfoTemplate {...props} />
    case 'product_details':
      return <ProductDetailsPage {...props} />
    default:
      return <InfoTemplate {...props} />
  }
}

export default ProductInfo